import React, { useLayoutEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const prefersReduced = typeof window !== 'undefined'
  && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export default function SiteFooter() {
  const root = useRef(null);

  useLayoutEffect(() => {
    if (prefersReduced) return;
    const ctx = gsap.context(() => {
      gsap.fromTo('.footer-word',
        { yPercent: 42, opacity: 0.4 },
        {
          yPercent: 0, opacity: 1, duration: 1, ease: 'power3.out',
          scrollTrigger: { trigger: '.footer-word-wrap', start: 'top 96%', once: true },
        },
      );
    }, root);
    return () => ctx.revert();
  }, []);

  return (
    <footer className="site-footer" ref={root}>
      <div className="footer-inner">
        <div className="footer-top">
          <div>
            <div className="footer-kicker">Next package</div>
            <Link to="/new" className="footer-cta" style={{ textDecoration: 'none' }}>
              Start a new analysis →
            </Link>
          </div>
          <div className="footer-col">
            Internal platform of<br />
            Hendriks Housing, Amsterdam<br />
            Every document read. Every risk surfaced.
          </div>
        </div>
        <div className="footer-word-wrap">
          <div className="footer-word" translate="no">DossierProof</div>
        </div>
        <div className="footer-meta">
          <span>© {new Date().getFullYear()} DossierProof · Internal use only</span>
          <span>AI advisory — every report signed off by an HH agent</span>
        </div>
      </div>
    </footer>
  );
}
